import React from 'react';
import { Upload, Spin } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useUploadFileToAi } from 'api/ai-parser/use-upload-file-to-ai';
import type { IOpenApiFileParse } from 'components/open-api-file-parser/types';

export const OpenApiFileParser: React.FC<IOpenApiFileParse> = ({ onFinish }) => {
  const { mutateAsync: uploadFile, isLoading } = useUploadFileToAi();

  const customRequest = async (options: any) => {
    const formData = new FormData();

    formData.append('file', options.file);

    const result = await uploadFile({
      data: formData,
      onUploadProgress: options.onProgress,
      onSuccess: options.onSuccess,
    });

    onFinish(result);
  };

  return (
    <Upload.Dragger
      name='files'
      customRequest={customRequest}
      showUploadList={false}
      disabled={isLoading}
      accept='application/pdf'>
      <p className='ant-upload-drag-icon'>{isLoading ? <Spin /> : <InboxOutlined />}</p>
      <p className='ant-upload-text'>{isLoading ? 'AI processing' : 'Click or drag file to this area to upload'}</p>
    </Upload.Dragger>
  );
};
